import Splide from '@splidejs/splide';
import { Translations } from '../utils';
import './news-evidenza.scss';

export class NewsEvidenza {
  constructor() {
    this.el = document.querySelector('.js-news-evidenza-slider');
    if (!this.el) return;

    this.breakpoint = 768;
    this.splide = null;

    this.init();
  }

  init() {
    this.checkSlider();
    window.addEventListener('resize', () => this.checkSlider());
  }

  checkSlider() {
    const isMobile = window.innerWidth < this.breakpoint;

    if (isMobile && !this.splide) {
      this.initSlider();
    }

    if (!isMobile && this.splide) {
      this.destroySlider();
    }
  }

  initSlider() {
    this.splide = new Splide(this.el, {
      type: 'slide',
      arrows: true,
      pagination: false,
      gap: '1rem',
      autoWidth: true,
      trimSpace: false,
      i18n: Translations.getSplideI18n(),
    });

    this.splide.mount();
  }

  destroySlider() {
    this.splide.destroy(true);
    this.splide = null;
  }
}
